import { statementOfBenefitsDetails } from './statement-of-benefits-details/statement-of-benefits-details.module';
import { statementOfBenefitsEdit } from './statement-of-benefits-edit/statement-of-benefits-edit.module';
import { StatementOfBenefitsService } from './statement-of-benefits.service';
import './statement-of-benefits.scss';

export const statementOfBenefits = angular
	.module('components.statement-of-benefits', [
        statementOfBenefitsDetails,
        statementOfBenefitsEdit
	])
    .service('StatementOfBenefitsService', StatementOfBenefitsService)
	.name;


// WEBPACK FOOTER //
// ./src/app/components/statement-of-benefits/statement-of-benefits.module.js